import type { ChipVariant } from "../types/smart-table";

export const PORTFOLIO_DIVIDEND_REVIEW_REASON = [
  "legacy-settlement-correction-required", "existing-income-match-unconfirmed", "confirmed-settlement-conflict",
] as const;
export type TPortfolioDividendReviewReason = (typeof PORTFOLIO_DIVIDEND_REVIEW_REASON)[number];
export const PORTFOLIO_DIVIDEND_REVIEW_REASON_OBJ = {
  LEGACY_SETTLEMENT_CORRECTION_REQUIRED: "legacy-settlement-correction-required",
  EXISTING_INCOME_MATCH_UNCONFIRMED: "existing-income-match-unconfirmed",
  CONFIRMED_SETTLEMENT_CONFLICT: "confirmed-settlement-conflict",
} as const satisfies Record<string, TPortfolioDividendReviewReason>;
export const PORTFOLIO_DIVIDEND_REVIEW_REASON_LABELS: Record<TPortfolioDividendReviewReason, Record<string, string>> = {
  "legacy-settlement-correction-required": { "en-US": "Saved payout needs a correction preview", "ru-RU": "Сохранённой выплате нужен предпросмотр уточнения" },
  "existing-income-match-unconfirmed": { "en-US": "Possible match with a saved payout", "ru-RU": "Возможно, эта выплата уже внесена" },
  "confirmed-settlement-conflict": { "en-US": "New details conflict with confirmed payout", "ru-RU": "Новые сведения противоречат подтверждённой выплате" },
};
export const PORTFOLIO_DIVIDEND_REVIEW_REASON_VARIANTS: Record<TPortfolioDividendReviewReason, ChipVariant> = {
  "legacy-settlement-correction-required": "outline", "existing-income-match-unconfirmed": "secondary", "confirmed-settlement-conflict": "destructive",
};
export const PORTFOLIO_DIVIDEND_IDENTITY_REVIEW_REASON = [
  PORTFOLIO_DIVIDEND_REVIEW_REASON_OBJ.LEGACY_SETTLEMENT_CORRECTION_REQUIRED,
  PORTFOLIO_DIVIDEND_REVIEW_REASON_OBJ.EXISTING_INCOME_MATCH_UNCONFIRMED,
] as const;
